import { constants } from "@newsela/angelou";
const white = constants.colors.ui.white[50];
const greyLight = constants.colors.ui.neutral[100];
const grey = constants.colors.ui.neutral[500];
const greyDark = constants.colors.ui.neutral[700];

const greyExtraLight = constants.colors.ui.neutral[25];
export const modalCss = ({ updatePending }) => ({
  root: { zIndex: 99 },
  footer: {
    minHeight: "auto",
    borderTop: updatePending ? "0px" : `1px ${greyLight} solid`,
  },
});

export const advisoryCheckboxCss = ({ acceptedContentAdvisory }) => ({
  root: {
    backgroundColor: greyExtraLight,
    paddingTop: ".5em",
    paddingBottom: ".5em",
    marginBottom: "1em",
  },
  labelText: {
    paddingLeft: "1em",
    color: acceptedContentAdvisory ? greyDark : grey,
  },
});

export const assignmentRowContentCss = {
  paddingTop: "1em",
  paddingBottom: "1em",
  display: "flex",
  flexDirection: "column",
};

export const assignmentDateCss = {
  root: {
    marginLeft: "3em",
    textTransform: "none",
    width: "fit-content",
  },
};

export const assignmentListCss = {
  "list-style-type": "none",
  marginBlockStart: 0,
  marginBlockEnd: 0,
  paddingLeft: 0,
};

export const modalInstructions = {
  marginTop: 5,
  marginRight: 10,
  marginBottom: 5,
  marginLeft: 10,
};

export const loadingWrapper = {
  alignItems: "center",
  display: "flex",
  justifyContent: "center",
  minHeight: "230px",
  minWidth: "100%",
};

export const toastWrapper = {
  "& a": {
    color: white,
    marginLeft: 10,
  },
  "& div": {
    display: "inline",
  },
};

export const modalWarning = ({ updatePending }) => ({
  visibility: updatePending ? "hidden" : "visible",
});

export const modalFooter = ({ updatePending }) => ({
  visibility: updatePending ? "hidden" : "visible",
  display: "inline-flex",
  justifyContent: "flex-end",
  width: "100%",
  "> div": {
    marginLeft: "10px",
  },
});

export const separatorCss = {
  border: 0,
  borderTop: `1px ${greyLight} solid`,
};
